var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMpReasonsKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6279 10.0579C25.2423 10.4514 25.0263 10.9803 25.0263 11.5312C25.0263 12.0821 25.2423 12.6111 25.6279 13.0045L28.9955 16.3721C29.3889 16.7577 29.9179 16.9737 30.4688 16.9737C31.0197 16.9737 31.5486 16.7577 31.9421 16.3721L39.8768 8.4373C40.9352 10.776 41.2556 13.3818 40.7955 15.9072C40.3353 18.4327 39.1164 20.758 37.3013 22.5731C35.4861 24.3883 33.1608 25.6072 30.6353 26.0674C28.1099 26.5275 25.5041 26.2071 23.1654 25.1487L8.62184 39.6923C7.78454 40.5296 6.6489 41 5.46477 41C4.28064 41 3.14501 40.5296 2.3077 39.6923C1.47039 38.855 1 37.7194 1 36.5352C1 35.3511 1.47039 34.2155 2.3077 33.3782L16.8513 18.8346C15.7929 16.4959 15.4725 13.8901 15.9327 11.3647C16.3928 8.83919 17.6117 6.51392 19.4269 4.69875C21.242 2.88357 23.5673 1.66469 26.0928 1.20454C28.6182 0.744398 31.224 1.06484 33.5627 2.12316L25.649 10.0369L25.6279 10.0579Z",
    stroke: "#02E2FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpReasonsKey);
export default __webpack_public_path__ + "static/media/mp-reasons-key.4c02b3c1a62d93e49ad002d3c729ed1f.svg";
export { ForwardRef as ReactComponent };